import Curl from "$common/utils/curl/browser-curl";
import AppCurl from "$common/utils/curl/app-curl";
import UrlModules from "$common/utils/curl/browser-curl/url-modules";

const gateway_web = 'gateway_web'

const appgatewayHost = new UrlModules({ module: "appgateway" });
const defaultCurl = (params, url, config) =>
  new Curl().curl(params, `${appgatewayHost.host}/${gateway_web}/${url}`, config);
const defaultAppCurl = (params, url, config) =>
  new AppCurl().curl(params, `/${url}`, config);
//  封装统一的请求
export const curlGateWay = (params, url, config) =>
  !!$vm?.$root?.isWownowApp
    ? defaultAppCurl(params, url, config)
    : defaultCurl(params, url, config);

// 券包列表
export const getCouponPackageList = (params, config) => defaultCurl(params, `takeaway-merchant/app/h5/coupon-package/list`, config);

// 券包详情
export const getCouponPackageDetail = (params, config) => defaultCurl(params, `takeaway-merchant/app/h5/coupon-package/info`, config);

// 订单详情
export const getCouponOrderDetail = (params, config) => curlGateWay(params, `takeaway-merchant/app/h5/user/coupon-package-order/get.do`, config);

// 购买历史
export const getCouponHistory = (params, config) => curlGateWay(params, `takeaway-merchant/app/h5/user/coupon-package-order/history.do`, config);

// 立即购买前置判断 
export const beforeBuy = (params, config) => curlGateWay(params, `takeaway-merchant/app/h5/buy-coupon-package/action.do`, config);

// 取消订单
export const cancelOrder = (params, config) => curlGateWay(params, `takeaway-merchant/app/h5/user/cancel-pay-coupon/action.do`, config);

// 查单
export const queryOrder = (params, config) => curlGateWay(params, `shop/order/queryDetail`, config);

// 查支付单
export const queryPayStatus = (params, config) => curlGateWay(params, `shop/boss/order/getPayStatus`, config);

// 券包根据经纬度查城市
export const queryCity = (params, config) => defaultCurl(params, `takeaway-merchant/app/h5/coupon-package/queryCity`, config);

// 当前有券包城市
export const queryEnableCity = (params, config) => defaultCurl(params, `takeaway-merchant/app/h5/coupon-package/queryEnableCity`, config);




